module.exports = __webpack_public_path__ + "img/visa.6fddabc2.svg";